// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"33e421da","26":"cb3dcc5e","176":"17276c9c","193":"c37b99e1","475":"89930c73"}[chunkId] + ".css";
};